<template>
  <div @click="$emit('cardSelected')">
    <sample-compact-card
      v-if="showCompactView"
      :sample="sample.samSamplenumber"
      :is-active="isActive"
      :is-child="true"
    />
    <b-card
      v-if="!showCompactView"
      qa="subsample-card"
      class="subSampleCard mt-2"
      :class="{'card-active': isActive, 'depleted-card': sample.isDepleted}"
    >
      <b-row>
        <b-col class="pt-1 pl-4 pr-2 pb-0 d-flex justify-content-between">
          <div class="d-flex pb-0 pt-1">
            <h4 class="mb-1">
              {{ sample.samSamplenumber }}
            </h4>
            <vtBubble
              v-if="sample.incidentsCount"
              :number="sample.incidentsCount"
              :type="true"
              :tooltip="' '+$tc('global.file',2)"
              @click="$emit('showIncidentsModal', sample.samId)"
            />
            <vtBubble
              v-if="sample.attachmentsCount"
              :number="sample.attachmentsCount"
              :type="false"
              :tooltip="' '+$tc('global.file',2)"
              @click="$emit('show-sample-attachment-tree-modal', sample.samId)"
            />
          </div>
          <div class="cardBtns mr-3">
            <i
              v-if="sample.process"
              v-tooltip="sample.process.name"
              class="fas fa-tint main"
              aria-hidden="true"
            />
            <i
              v-if="sample.samSpecialPreserve"
              v-tooltip="$t('grossing.labels.preserve') + ': ' + (sample.samDaysBeforeDisposal ? (sample.samDaysBeforeDisposal + ' ' + $t('grossing.labels.days')) : $t('grossing.content.presOptionIndefinite'))"
              class="fas fa-clock main"
              aria-hidden="true"
            />
            <i
              v-if="sample.samFixerFxrId"
              v-tooltip="sample.samFixerFxrCode"
              class="fas fa-certificate main"
              aria-hidden="true"
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <hr class="p-0 mt-0 mb-1 mx-2">
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="11"
          class="pt-0 pl-4 pr-2 pb-1"
        >
          <div class="d-flex pb-0">
            <span>{{ sample.sampleType.description }}</span>
          </div>
          <common-sample-status-badge :status="sample.status" />
          <div v-if="sample.isDepleted">
            <span class="depleted-text"><i
              class="far fa-empty-set mr-1"
              aria-hidden="true"
            />{{ $t('global.depletedSample') }}</span>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import VtBubble from '@/components/common/VtBubble'
import SampleCompactCard from '@/components/samplesCards/SampleCompactCard'
import CommonSampleStatusBadge from '@/components/common/CommonSampleStatusBadge'

export default {
    name: 'SubSampleCard',
    components: {
        VtBubble,
        SampleCompactCard,
        CommonSampleStatusBadge
    },
    props: {
        sample: { type: Object, default: () => {} },
        isActive: { type: Boolean, default: false },
        showCompactView: { type: Boolean, default: false }
    },
    data() {
        return {}
    },
    methods: {}
}

</script>

<style lang="scss" scoped>

  .subSampleCard {
    box-shadow: 0 2px 5px 0 #9c9c9c;
    cursor: pointer;
    border-left: 4px solid transparent;
  }

  .subSampleCard.depleted-card {
    border-left: 5px solid vt-color(depleted-card);
  }

  .subSampleCard.depleted-card .card-body {
      background: vt-color(depleted-card);
  }

  .subSampleCard:hover {
    box-shadow: 0 5px 8px 0 #9c9c9c;
  }

  .subSampleCard h4 {
    font-weight: normal;
  }

  .subSampleCard span {
    font-size: 0.9rem;
    color: #303133;
    margin-top: -5px;
  }

  .subSampleCard .cardBtns i {
    padding: 2px;
  }

  .card-active {
      border-left: 5px solid vt-color(primary) !important;
      box-shadow: 1px 2px 3px 2px #9c9c9c;
  }

  .subSampleCard .badge{
    font-weight: normal;
    font-size: font-size(very-tiny) !important;
  }

</style>
